<template>
    <div class="index-game-page">
        <div class="tag-list-comp" ref="tagListComp">
            <div class="tag-wrap">
                <span class="tag-title">标签筛选：</span>
                <div class="wrap-inner" :style="wrapInnerStyle" ref="wrap">
                    <span ref="tagSp" v-debounce="[() => handlerClick(item), 'click', 150]" class="tag-item" :class="{ active: item.id == activeId }" v-for="(item, index) in tagList" :key="`${item.id}-${index}`">{{ item.name }}</span>
                </div>
            </div>
            <div class="more" v-if="showAllPickUp" @click="handleExpand">
                <span>{{ isExpanded ? '收回' : '更多' }}</span>
                <span class="icon"></span>
            </div>
        </div>
        <div class="game-list-wrap hide-scroll" @scroll="scrollHandler" ref="gameListWrap" :style="scrollSecStyle">
            <div class="game-inner">
                <RecGameItem class="item" type="game-index" v-for="item in gameList" :key="item.id" :game-info="item"></RecGameItem>
            </div>
            <DataLoader :class="{ 'loader-sec': !gameList.length }" :loading="loading" :data="gameList"></DataLoader>
        </div>
    </div>
</template>
<script>
import { gameDatabase, getFreeGameList } from '@/http/api/game.js'
import { queryTagGroup } from '@/http/api/order.js'
import { mapState } from 'vuex'
import { cancelRequest } from '@/http'

export default {
    name: 'IndexGame',
    props: {
        indexTop: {
            type: Number,
            default: 0
        }
    },
    data() {
        return {
            tagList: [],
            activeId: 0,
            query: {
                page: 1,
                size: 20,
                group_id: 0,
                name: this.$store.state.topSearchKeyword,
                sort: '',
                mode: 1
            },
            gameList: [],
            loading: false,
            loadingFinish: false,
            loadingError: false,
            scrollTop: 0,
            tagList: [],
            isExpanded: false,
            showAllPickUp: false,
            wrapContentHeight: 0,
            tagListCompHeight: 0,
            first: false
        }
    },
    computed: {
        ...mapState(['topSearchKeyword', 'needRefreshGame']),
        wrapInnerStyle() {
            return {
                height: this.isExpanded ? this.wrapContentHeight + 'px' : '28px'
            }
        },
        scrollSecStyle() {
            return {
                height: this.isExpanded ? `calc(100% - ${this.tagListCompHeight}px)` : 'calc(100% - 56px)'
            }
        }
    },
    mounted() {
        this.gameDatabase()
        this.getAllTag()
        this.$EventBus.$on('search-game', () => {
            this.$emit('set-nav')
            this.searchGame()
        })
        this.first = true
    },
    beforeDestroy() {
        this.$EventBus.$off('search-game')
    },
    activated() {
        this.$refs.gameListWrap.scrollTop = this.indexTop || this.scrollTop
        if (this.needRefreshGame && !this.first) {
            this.searchGame()
            this.$store.commit('setNeedRefreshGame', false)
        }

        let { scrollTop, offsetHeight } = this.$refs.gameListWrap.scrollTop
        if (scrollTop > offsetHeight / 2) {
            this.$emit('set-back-top', true)
        } else {
            this.$emit('set-back-top', false)
        }
    },
    deactivated() {
        this.first = false
    },
    methods: {
        searchGame() {
            this.query.page = 1
            this.query.name = this.topSearchKeyword
            this.gameList = []
            this.loading = false
            this.loadingFinish = false
            this.loadingError = false
            this.cancelRequest()
            this.gameDatabase()
        },
        handlerClick(item) {
            if (this.activeId == item.id) {
                this.activeId = 0
                this.query.group_id = 0
                this.query.sort = ''
                this.query.is_arch = ''
            } else {
                this.activeId = item.id
                this.query.group_id = item.id

                // 最新、最热、支持云存档选项特殊处理
                if (item.id == -3) {
                    this.query.is_arch = 1
                    this.query.group_id = 0
                    this.query.sort = ''
                } else if (item.id == -2) {
                    this.query.sort = 1
                    this.query.group_id = 0
                    this.query.is_arch = ''
                } else if (item.id == -1) {
                    this.query.sort = 2
                    this.query.group_id = 0
                    this.query.is_arch = ''
                } else {
                    this.query.sort = ''
                    this.query.is_arch = ''
                }
            }

            this.searchGame()
        },
        getAllTag() {
            const query = {
                page: 1,
                size: 100
            }
            queryTagGroup(query).then((res) => {
                if (res.code == 200 && Array.isArray(res.data.list)) {
                    let list = res.data.list
                    this.tagList = [{ id: -2, name: '最新', sort: true }, { id: -1, name: '最热', sort: true }, { id: -3, name: '支持云存档', sort: false }, ...list]
                    this.$nextTick(() => {
                        if (this.$refs.wrap) {
                            this.wrapContentHeight = this.$refs.wrap.scrollHeight
                            let calcSpStyle = getComputedStyle(this.$refs.tagSp[0])
                            let calcHeight = parseInt(calcSpStyle.height) + parseInt(calcSpStyle.marginBottom)
                            if (this.wrapContentHeight > calcHeight) {
                                this.showAllPickUp = true
                            }
                        }
                    })
                }
            })
        },
        handleExpand() {
            this.isExpanded = !this.isExpanded
            if (this.isExpanded) {
                this.tranTimeId = setTimeout(() => {
                    clearTimeout(this.tranTimeId)
                    this.$nextTick(() => {
                        let calcStyle = getComputedStyle(this.$refs.tagListComp)
                        this.tagListCompHeight = parseInt(calcStyle.height) + parseInt(calcStyle.marginBottom)
                    })
                }, 300)
            }
        },
        gameDatabase() {
            this.loading = true
            gameDatabase(this.query)
                .then(async (res) => {
                    this.loading = false

                    if (res.code == 200) {
                        this.loadingError = false
                        if (Array.isArray(res.data.list)) {
                            let list = res.data.list
                            this.gameList = [...this.gameList, ...list.map((v) => ({ ...v, is_free: -1, isCompare: false }))]
                            if (this.query.size > res.data.list.length) {
                                this.loadingFinish = true
                            }
                            let tempGameIds = Array.from(new Set(list.map((v) => v.game_id)))
                            this.getFreeGameList(tempGameIds)
                        }
                    } else {
                        this.loadingError = true
                    }
                })
                .catch((err) => {
                    this.loading = false
                    this.loadingError = true
                })
        },
        getFreeGameList(gameIds) {
            let tempGameIds = `[${gameIds.join(',')}]`
            getFreeGameList({ page: 1, size: 60, gameIds: tempGameIds }).then((res) => {
                if ((res.code = 200 && Array.isArray(res.data.list))) {
                    let list = res.data.list
                    this.gameList.forEach((v1) => {
                        if (!v1.isCompare) {
                            // 只查找没有比较过的，并且是有goods_id的
                            let index = list.findIndex((v2) => v1.goods_id && v1.game_id == v2.game_id)
                            if (index > -1) {
                                v1.is_free = 1
                            } else {
                                v1.is_free = 0
                            }
                            v1.isCompare = true
                        }
                    })
                }
            })
        },
        scrollHandler(e) {
            this.scrollTop = this.$refs.gameListWrap.scrollTop
            if (this.scrollTop > e.target.offsetHeight / 2) {
                this.$emit('set-back-top', true)
            } else {
                this.$emit('set-back-top', false)
            }
            this.$emit('set-top', { name: 'indexTop', value: this.scrollTop })
            if (this.loading) return false
            if (this.loadingFinish) return false

            let el = e.target
            let scrollTop = el.scrollTop
            this.scrollTop = scrollTop

            // 获取可视区的高度
            let clientHeight = el.clientHeight
            // 获取滚动条的总高度
            let scrollHeight = el.scrollHeight
            if (scrollTop + clientHeight >= scrollHeight - 100) {
                if (this.loadingError) {
                } else if (!this.loadingFinish && !this.loading) {
                    this.query.page++
                }

                this.gameDatabase()
            }
        },
        cancelRequest() {
            // cancelRequest('/box/boxFamily/information/list')
            cancelRequest('/box/goods/list')
            cancelRequest('/box/boxFamily/gamefree/list')
        }
    }
}
</script>
<style lang="less" scoped>
.index-game-page {
    height: 100%;
    color: @color-txt-high;
    position: relative;

    .tag-list-comp {
        font-size: 0;
        display: flex;
        align-items: flex-start;
        margin-bottom: 28px;

        .tag-wrap {
            display: flex;
            flex: 1;
            align-items: flex-start;
            flex-wrap: nowrap;
            overflow: hidden;
            font-size: 0;

            .tag-title {
                font-size: 14px;
                color: @color-txt-normal;
                margin-right: 9px;
                flex-shrink: 0;
                padding-top: 4px;
            }

            .wrap-inner {
                height: 28px;
                overflow: hidden;

                .tag-item {
                    margin-right: 6px;
                    margin-bottom: 6px;
                    display: inline-block;
                    cursor: pointer;
                    padding: 0 11px;
                    height: 26px;
                    font-size: 14px;
                    line-height: 26px;
                    background: #252F35;
                    border-radius: 13px;
                    color: @color-txt-normal;
                    transition: 0.3s;
                    flex-shrink: 0;

                    &.active {
                        color: @color-txt-high;
                    }
                }
            }
        }

        .more {
            display: flex;
            align-items: center;
            flex-shrink: 0;
            font-size: 14px;
            margin-left: 10px;
            cursor: pointer;
            color: @color-txt-normal;
            padding-top: 5px;

            &:hover {
                color: @color-txt-high;

                .icon {
                    background-image: url(../../../assets/arrow_more_1.png);
                }
            }

            .icon {
                margin-left: 5px;
                width: 8px;
                height: 7px;
                background: url(../../../assets/arrow_more.png) center/100% no-repeat;
            }
        }
    }

    .game-list-wrap {
        height: calc(100% - 56px);
        width: 1337px;
        overflow-y: auto;

        .game-inner {
            display: flex;
            flex-wrap: wrap;

            .item {
                margin-right: 20px;
                margin-bottom: 20px;

                &:nth-child(4n) {
                    margin-right: 0;
                }
            }
        }

        .loader-sec {
            margin-top: 160px;
        }

        .loader {
            margin: 0 auto;
            width: 128px;
            height: 48px;
            background: url(../../../assets/loading.gif) center no-repeat;
            background-size: 100% 100%;
        }
    }
}
</style>
